import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: {
      name: "",
      phoneNumber: "",
      country: "",
      trialActivated: false,
      daysLeftInTrial: 0,
      email: "",
      subscriptionActivated: false,
      profilePicture: null,
    },
    loggedIn: false,
    auth: {},
  },
  reducers: {
    setUserDataAction: (state, action) => {
      state.user = action.payload;
    },
    setLoggedIn: (state, action) => {
      state.loggedIn = action.payload;
    },
    setAuthToken: (state, action) => {
      state.auth = action.payload;
    },
  },
});

export const { setUserDataAction, setLoggedIn, setAuthToken } =
  userSlice.actions;

export default userSlice.reducer;
